import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./MultipleChoiceTabs.css";
import InstructivoEcbt from "./InstructivoEcbt";
import InstructivoProyecto from "./InstructivoProyecto";
import { Financiamiento, projectService, Proyecto } from "api/projectService";
import { Box, TextField, Divider, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, FormHelperText, RadioGroup, Radio, FormControlLabel, Card } from "@mui/material";
import { questionService } from "api/questionService";
import { AddCircle, Delete } from "@mui/icons-material";


interface FormErrors {
    nombre?: string;
    organizacion?: string;
    tipoOrganizacion?: string;
    tipoProyecto?: string;
    tipoSector?: string;
    programa?: string;
    nombreContacto?: string;
    emailContacto?: string;
    descripcion?: string;
    lideraMujer?: string;
    idRegion?: string;
}

export interface ModelSelectorProps {
    proyecto: Proyecto;
    onToggleFlag: (num?: number, inProyecto?: Proyecto) => void;
}

export default function ModelSelector({ proyecto: inProyecto, onToggleFlag }: ModelSelectorProps) {
    const primaryBlue = "#0051A8";
    //const [modelSelected, setModelSelected] = useState<number>(selectedModel);
    const [isTypeSelected, setTypeSelected] = useState(false);
    const [proyecto, setProyecto] = useState<Proyecto>(inProyecto);
    const [errors, setErrors] = useState<FormErrors>({});
    const [loading, setLoading] = useState(false)

    const [dataPairs, setDataPairs] = useState<Financiamiento[]>(() => {
        if (proyecto.financiamiento && proyecto.financiamiento.length > 0) {
            return proyecto.financiamiento;
        } else {
            return [{ tipoFinanciamiento: "", codigoFinanciamiento: "" }];
        }
    });

    const getErrors = () => {
        let tempErrors: FormErrors = {};
        tempErrors.nombre = proyecto.nombre ? "" : "El nombre del proyecto es obligatorio";
        tempErrors.organizacion = proyecto.organizacion ? "" : "El nombre de la organización es obligatorio";
        tempErrors.tipoOrganizacion = proyecto.tipoOrganizacion ? "" : "Selecciones un tipo de organización";
        tempErrors.tipoProyecto = proyecto.tipoProyecto ? "" : "Seleccione un tipo de proyecto";
        tempErrors.tipoSector = proyecto.tipoSector ? "" : "Seleccione un sector tecnológico";
        tempErrors.programa = proyecto.programa ? "" : "Seleccione un programa";
        tempErrors.nombreContacto = proyecto.nombreContacto ? "" : "El nombre de contacto es obligatorio";
        tempErrors.descripcion = proyecto.descripcion ? "" : "La descripción es obligatoria";
        tempErrors.lideraMujer = proyecto.lideraMujer !== null ? "" : "Seleccione si el proyecto es liderado por una mujer";
        tempErrors.idRegion = proyecto.idRegion !== "0" ? "" : "La región es obligatoria";
        tempErrors.emailContacto = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(proyecto.emailContacto) ? "" : "Ingrese un email válido";
        return tempErrors;
    }
    const validate = () => {
        let tempErrors = getErrors();
        setErrors(tempErrors);
        return Object.values(tempErrors).every(x => x === "");
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (proyecto.nuevaEvaluacion !== null) {
            if (!proyecto.nuevaEvaluacion.activa) {
                onToggleFlag(1, proyecto);
                return;
            }
        }
        try{

            setLoading(true)
            if (validate()) {
                setTypeSelected(true);

                //const financiamiento = dataPairs.filter(f => f.tipoFinanciamiento !== 'N/A');
                const financiamiento = dataPairs;
                console.log("va a guardar:" + JSON.stringify(financiamiento));
                const id = await projectService.save({ ...proyecto, financiamiento: financiamiento });
                console.log("guardado");
                setProyecto(prevProyecto => {

                    const newProyecto = { ...prevProyecto, idProyecto: id, financiamiento: dataPairs }; // Usar el ID devuelto
                    console.log("Formulario válido", newProyecto);

                    return newProyecto;
                });

                let evaluacion = proyecto.nuevaEvaluacion;
                if (proyecto.nuevaEvaluacion === null) {
                    evaluacion = await questionService.crearEvaluacion({ ...proyecto, idProyecto: id });
                }
                setProyecto(prevProyecto => {

                    const newProyecto = { ...prevProyecto, nuevaEvaluacion: evaluacion }; // Usar el ID devuelto
                    console.log("Formulario válido con evaluacion", newProyecto);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    onToggleFlag(1, newProyecto);
                    return newProyecto;
                });
                console.log("Formulario válido guardado", proyecto);
            } else {
                setTypeSelected(false);
                console.log("Formulario inválido->>" + JSON.stringify(getErrors()));
            }

        }catch(error){
            console.log("Error al guardar",error);
        }finally{
            setLoading(false)
        }

    };

    const handleTab = async (num: number, inProyecto: Proyecto) => {

        if (proyecto.nuevaEvaluacion === null) {
            const evaluacion = await questionService.crearEvaluacion(inProyecto);
            setProyecto(prevProyecto => {

                const newProyecto = { ...prevProyecto, nuevaEvaluacion: evaluacion }; // Usar el ID devuelto
                console.log("Formulario válido con evaluacion handleTab", newProyecto);
                onToggleFlag(1, newProyecto);
                return newProyecto;
            });
        } else {
            onToggleFlag(num, inProyecto);
        }


    }

    const handlePairChange = (index: number, field: "tipoFinanciamiento" | "codigoFinanciamiento", value: string) => {
        const newPairs = [...dataPairs];
        if (field === "tipoFinanciamiento" && value === 'N/A') {
            newPairs[index]["codigoFinanciamiento"] = "NO APLICA";
            newPairs[index]["tipoFinanciamiento"] = 'N/A'
        } else {
            if (newPairs[index]["codigoFinanciamiento"] === 'NO APLICA') {
                newPairs[index]["codigoFinanciamiento"] = '';
            }
            
        }
        newPairs[index][field] = value;
        setDataPairs(newPairs);
    };
    const handleAddPair = () => {
        setDataPairs([...dataPairs, { tipoFinanciamiento: "", codigoFinanciamiento: "" }]);
    };
    const handleRemovePair = (index: number) => {
        const newPairs = [...dataPairs];
        newPairs.splice(index, 1);
        setDataPairs(newPairs);
    };

    useEffect(() => {
        let tempErrors = getErrors();

        setTypeSelected((Object.values(tempErrors).every(x => x === "") && proyecto.idProyecto === 0) || proyecto.nuevaEvaluacion === null ? false : true);
    }, [proyecto]);

    return (
        <div className="containerMultipleChoiceTabs">
            <motion.div
                className="mxAuto">
                    {
                        proyecto.nuevaEvaluacion === null?   
                            <div className="tabsHeader">
                                <button className="tabButton2 tabButtonActive2">Proyecto</button>
                                <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(1, proyecto)}>CRL</button>
                                <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(2, proyecto)}>BRL</button>
                                <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(3, proyecto)}>TRL</button>
                                <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(4, proyecto)}>IPRL</button>
                                <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(5, proyecto)}>TmRL</button>
                                <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(6, proyecto)}>FRL</button>
                            </div>
                            :
                            proyecto.nuevaEvaluacion?.rls[0].questions[0].answers[0].answerId===null?
                                <div className="tabsHeader">
                                    <button className="tabButton2 tabButtonActive2">Proyecto</button>
                                    <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(1, proyecto)}>BRL</button>
                                    <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(2, proyecto)}>TRL</button>
                                    <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(3, proyecto)}>IPRL</button>
                                    <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(4, proyecto)}>TmRL</button>
                                    <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(5, proyecto)}>FRL</button>
                                </div>
                                :
                                <div className="tabsHeader">
                                    <button className="tabButton2 tabButtonActive2">Proyecto</button>
                                    <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(1, proyecto)}>CRL</button>
                                    <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(2, proyecto)}>BRL</button>
                                    <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(3, proyecto)}>TRL</button>
                                    <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(4, proyecto)}>IPRL</button>
                                    <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(5, proyecto)}>TmRL</button>
                                    <button className={` ${isTypeSelected ? "tabButton2" : "tabButton2Disabled"}`} disabled={!isTypeSelected} onClick={() => handleTab(6, proyecto)}>FRL</button>
                                </div>
                    }
                

                <div className="mxAuto">
                    <form onSubmit={handleSubmit} className="card">

                        <Box className="home-component"
                            sx={{ width: 600, marginTop: 3, marginBottom: 5, backgroundColor: "white" }}>

                            <p className="paragraph">
                                {proyecto.idProyecto === 0 ? "Para partir, ingresa algunos datos básicos del Proyecto." : ""}
                            </p>
                            <TextField disabled={proyecto.nuevaEvaluacion === null ? false : (!proyecto.nuevaEvaluacion.activa)} value={proyecto.organizacion}
                                onChange={(e) => setProyecto({ ...proyecto, organizacion: e.target.value })}
                                error={!!errors.organizacion} helperText={errors.organizacion}
                                required fullWidth type="text" label="Nombre organización" sx={{ mb: 1 }} />


                            <FormControl disabled={proyecto.nuevaEvaluacion === null ? false : (!proyecto.nuevaEvaluacion.activa)} required fullWidth error={!!errors.tipoSector}>
                                <InputLabel id="select-tipo-organizacion">Tipo de organización</InputLabel>
                                <Select value={proyecto.tipoOrganizacion}
                                    onChange={(e) => setProyecto({ ...proyecto, tipoOrganizacion: e.target.value })}
                                    fullWidth labelId="select-tipo-sector" label="Tipo de organización" sx={{ mb: 1 }}>
                                    <MenuItem value={"Institución Educación Superior (IES); Centro I+D / Tecnológico"}>Institución Educación Superior (IES); Centro I+D / Tecnológico</MenuItem>
                                    <MenuItem value={"Hub/ Incubadora /Aceleradora"}>Hub/ Incubadora /Aceleradora</MenuItem>
                                    <MenuItem value={"Organismo Sector Público"}>Organismo Sector Público</MenuItem>
                                    <MenuItem value={"Empresa"}>Empresa</MenuItem>
                                    <MenuItem value={"StartUp / EBCT"}>StartUp / EBCT</MenuItem>
                                    <MenuItem value={"Fondo de Inversión"}>Fondo de Inversión</MenuItem>
                                    <MenuItem value={"Cuenta individual"}>Cuenta individual</MenuItem>
                                </Select>
                                <FormHelperText>{errors.tipoOrganizacion}</FormHelperText>
                            </FormControl>
                            <TextField disabled={proyecto.nuevaEvaluacion === null ? false : (!proyecto.nuevaEvaluacion.activa)} value={proyecto.nombre}
                                onChange={(e) => setProyecto({ ...proyecto, nombre: e.target.value })}
                                error={!!errors.nombre} helperText={errors.nombre}
                                required fullWidth type="text" label="Nombre proyecto" sx={{ mb: 1 }} />
                            <TextField disabled={proyecto.nuevaEvaluacion === null ? false : (!proyecto.nuevaEvaluacion.activa)} value={proyecto.descripcion}
                                onChange={(e) => setProyecto({ ...proyecto, descripcion: e.target.value })}
                                error={!!errors.descripcion} helperText={errors.descripcion}
                                required fullWidth type="text" label="Síntesis del proyecto" sx={{ mb: 1 }} multiline rows={2}
                                inputProps={{ maxLength: 1000 }} />
                            <FormControl disabled={proyecto.nuevaEvaluacion === null ? false : (!proyecto.nuevaEvaluacion.activa)} required fullWidth error={!!errors.tipoSector}>
                                <InputLabel id="select-tipo-sector">Sector tecnológico</InputLabel>
                                <Select value={proyecto.tipoSector}
                                    onChange={(e) => setProyecto({ ...proyecto, tipoSector: e.target.value })}
                                    fullWidth labelId="select-tipo-sector" label="Sector de impacto" sx={{ mb: 1 }}>
                                    <MenuItem value={"Analítica Avanzada"}>Analítica Avanzada</MenuItem>
                                    <MenuItem value={"Biotecnología"}>Biotecnología</MenuItem>
                                    <MenuItem value={"Ciberseguridad"}>Ciberseguridad</MenuItem>
                                    <MenuItem value={"Computación de Alto Desempeño"}>Computación de Alto Desempeño</MenuItem>
                                    <MenuItem value={"Dispositivos Médicos"}>Dispositivos Médicos</MenuItem>
                                    <MenuItem value={"Energía"}>Energía</MenuItem>
                                    <MenuItem value={"Fotónica"}>Fotónica</MenuItem>
                                    <MenuItem value={"Inteligencia Artificial"}>Inteligencia Artificial</MenuItem>
                                    <MenuItem value={"Internet de las Cosas"}>Internet de las Cosas</MenuItem>
                                    <MenuItem value={"Manufactura Avanzada"}>Manufactura Avanzada</MenuItem>
                                    <MenuItem value={"Materiales Avanzados"}>Materiales Avanzados</MenuItem>
                                    <MenuItem value={"Medioambiente"}>Medioambiente</MenuItem>
                                    <MenuItem value={"Movilidad"}>Movilidad</MenuItem>
                                    <MenuItem value={"Nanotecnología"}>Nanotecnología</MenuItem>
                                    <MenuItem value={"Otros tópicos"}>Otros tópicos</MenuItem>
                                    <MenuItem value={"Realidad Virtual o Aumentada"}>Realidad Virtual o Aumentada</MenuItem>
                                    <MenuItem value={"Robótica"}>Robótica</MenuItem>
                                    <MenuItem value={"Salud Digital"}>Salud Digital</MenuItem>
                                    <MenuItem value={"Semiconductores"}>Semiconductores</MenuItem>
                                    <MenuItem value={"Sistemas de Instrumentación"}>Sistemas de Instrumentación</MenuItem>
                                    <MenuItem value={"Tecnologías Biomédicas"}>Tecnologías Biomédicas</MenuItem>
                                    <MenuItem value={"Tecnologías para la Enseñanza"}>Tecnologías para la Enseñanza</MenuItem>
                                    <MenuItem value={"Tecnología Farmacéutica"}>Tecnología Farmacéutica</MenuItem>
                                    <MenuItem value={"Tecnología Química"}>Tecnología Química</MenuItem>
                                    <MenuItem value={"Tecnologías Inalámbricas"}>Tecnologías Inalámbricas</MenuItem>
                                </Select>
                                <FormHelperText>{errors.tipoSector}</FormHelperText>
                            </FormControl>
                            <FormControl disabled={proyecto.idProyecto != 0 ? true : proyecto.nuevaEvaluacion === null ? false : (!proyecto.nuevaEvaluacion.activa)} required fullWidth error={!!errors.tipoProyecto}>
                                <InputLabel id="select-tipo-proyecto">Tipo de proyecto</InputLabel>
                                <Select value={proyecto.tipoProyecto}
                                    inputProps={{ readOnly: proyecto.idProyecto != 0 }}
                                    onChange={(e) => {
                                        setProyecto({ ...proyecto, tipoProyecto: e.target.value });
                                    }}
                                    label="Tipo de proyecto" sx={{ mb: 1 }} labelId="select-tipo-proyecto" >
                                    <MenuItem value={"1"}>Startup/EBCT</MenuItem>
                                    <MenuItem value={"2"}>Tecnología</MenuItem>
                                </Select>
                                <FormHelperText>{errors.tipoProyecto}</FormHelperText>
                            </FormControl>

                            <FormControl disabled={proyecto.nuevaEvaluacion === null ? false : (!proyecto.nuevaEvaluacion.activa)} required fullWidth error={!!errors.idRegion}>
                                <InputLabel id="select-tipo-sector">Región del proyecto</InputLabel>
                                <Select value={proyecto.idRegion}
                                    onChange={(e) => setProyecto({ ...proyecto, idRegion: e.target.value })}
                                    fullWidth labelId="select-tipo-sector" label="Región del proyecto" sx={{ mb: 1 }}>
                                    <MenuItem value={"1"}>Tarapacá</MenuItem>
                                    <MenuItem value={"2"}>Antofagasta</MenuItem>
                                    <MenuItem value={"3"}>Atacama</MenuItem>
                                    <MenuItem value={"4"}>Coquimbo</MenuItem>
                                    <MenuItem value={"5"}>Valparaíso</MenuItem>
                                    <MenuItem value={"6"}>Libertador General Bernardo O’Higgins</MenuItem>
                                    <MenuItem value={"7"}>Maule</MenuItem>
                                    <MenuItem value={"8"}>Biobío</MenuItem>
                                    <MenuItem value={"9"}>La Araucanía</MenuItem>
                                    <MenuItem value={"10"}>Los Lagos</MenuItem>
                                    <MenuItem value={"11"}>Aysén del General Carlos Ibáñez del Campo</MenuItem>
                                    <MenuItem value={"12"}>Magallanes y de la Antártica Chilena</MenuItem>
                                    <MenuItem value={"13"}>Metropolitana de Santiago</MenuItem>
                                    <MenuItem value={"14"}>Los Ríos</MenuItem>
                                    <MenuItem value={"15"}>Arica y Parinacota</MenuItem>
                                    <MenuItem value={"16"}>Ñuble</MenuItem>
                                </Select>
                                <FormHelperText>{errors.idRegion}</FormHelperText>
                            </FormControl>

                            <FormControl disabled={proyecto.nuevaEvaluacion === null ? false : (!proyecto.nuevaEvaluacion.activa)} required component="fieldset" error={!!errors.lideraMujer} fullWidth sx={{ mb: 2 }}>
                                <div>¿Es un proyecto liderado por una mujer?*</div>
                                <RadioGroup
                                    row
                                    value={proyecto.lideraMujer === null ? null : proyecto.lideraMujer ? "si" : "no"}
                                    onChange={(e) => setProyecto({ ...proyecto, lideraMujer: e.target.value === "si" })}
                                >
                                    <FormControlLabel
                                        value="si"
                                        control={<Radio sx={{ color: primaryBlue, '&.Mui-checked': { color: primaryBlue } }} />}
                                        label="Sí"
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio sx={{ color: primaryBlue, '&.Mui-checked': { color: primaryBlue } }} />}
                                        label="No"
                                    />
                                </RadioGroup>
                                <FormHelperText>{errors.lideraMujer}</FormHelperText>
                            </FormControl>

                            <FormControl disabled={proyecto.nuevaEvaluacion === null ? false : (!proyecto.nuevaEvaluacion.activa)} required fullWidth error={!!errors.programa}>
                                <InputLabel id="select-program">Institución / Programa</InputLabel>
                                <Select value={proyecto.programa}
                                    onChange={(e) => setProyecto({ ...proyecto, programa: e.target.value })}
                                    label="Institución / Programa" sx={{ mb: 1 }} labelId="select-program" >
                                    <MenuItem value={"hubtec"}>HUBTEC</MenuItem>
                                    <MenuItem value={"apta"}>APTA</MenuItem>
                                    <MenuItem value={"knowhub"}>KNOW HUB</MenuItem>
                                    <MenuItem value={"anid"}>ANID</MenuItem>
                                    <MenuItem value={"otro"}>OTRO</MenuItem>
                                </Select>
                                <FormHelperText>{errors.programa}</FormHelperText>
                            </FormControl>




                            <TextField disabled={proyecto.nuevaEvaluacion === null ? false : (!proyecto.nuevaEvaluacion.activa)} value={proyecto.nombreContacto}
                                onChange={(e) => setProyecto({ ...proyecto, nombreContacto: e.target.value })}
                                error={!!errors.nombreContacto} helperText={errors.nombreContacto}
                                required fullWidth type="text" label="Nombre contacto" sx={{ mb: 1 }} />
                            <TextField disabled={proyecto.nuevaEvaluacion === null ? false : (!proyecto.nuevaEvaluacion.activa)} value={proyecto.emailContacto}
                                onChange={(e) => setProyecto({ ...proyecto, emailContacto: e.target.value })}
                                error={!!errors.emailContacto} helperText={errors.emailContacto}
                                required fullWidth type="text" label="Email contacto" sx={{ mb: 1 }} />

                            <Divider textAlign="left" sx={{ color: "#666666", mb: 2, mt: 1 }}>
                                Fuente{dataPairs.length > 1 ? 's' : ''} de Financiamiento
                            </Divider>
                            {dataPairs.map((pair, index) => (

                                <Box key={index} display="flex" gap={2} alignItems="center" sx={{ position: "relative", width: 570 }}>
                                    <Box sx={{ flex: 1 }}>
                                        <FormControl fullWidth required disabled={proyecto.nuevaEvaluacion === null ? false : (!proyecto.nuevaEvaluacion.activa)}>
                                            <InputLabel id={`select-tipo-${index}`}>Tipo de Financiamiento{index > 0 ? ' ' + (index + 1) : ''}</InputLabel>
                                            <Select sx={{ mb: 1 }}
                                                labelId={`select-tipo-${index}`}
                                                value={pair.tipoFinanciamiento}
                                                label={`Tipo de Financiamiento` + (index > 0 ? ' ' + (index + 1) : '')}
                                                onChange={(e) => handlePairChange(index, "tipoFinanciamiento", e.target.value)}
                                            >
                                                <MenuItem value="CORFO">CORFO</MenuItem>
                                                <MenuItem value="ANID">ANID</MenuItem>
                                                <MenuItem value="OTRO">OTRO</MenuItem>
                                                <MenuItem value="N/A">NO APLICA</MenuItem>
                                            </Select>
                                        </FormControl>

                                        <TextField required sx={{ mb: 1 }} disabled={proyecto.nuevaEvaluacion === null ? (dataPairs[index].tipoFinanciamiento === 'N/A') : (!proyecto.nuevaEvaluacion.activa || dataPairs[index].tipoFinanciamiento === 'N/A')}
                                            label={"Código de Financiamiento" + (index > 0 ? ' ' + (index + 1) : '')}
                                            fullWidth
                                            value={pair.codigoFinanciamiento}
                                            onChange={(e) => handlePairChange(index, "codigoFinanciamiento", e.target.value)}
                                        />
                                    </Box>

                                    <Box sx={{ position: "absolute", right: -120, flexDirection: "column", alignItems: "center", minWidth: "120px" }}>
                                        {
                                            (proyecto.nuevaEvaluacion === null ? false : (!proyecto.nuevaEvaluacion.activa)) ?
                                                <></> :
                                                <>{(dataPairs.length - 1) === index ? (
                                                    <Button
                                                        onClick={handleAddPair}
                                                        size="small"
                                                        sx={{
                                                            minWidth: "auto",
                                                            padding: 1,
                                                            color: primaryBlue,
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(0, 28, 65, 0.08)',
                                                            },
                                                        }}
                                                    >
                                                        <AddCircle fontSize="large" />
                                                    </Button>
                                                ) : null}

                                                    {dataPairs.length > 1 ? (
                                                        <Button color="error" onClick={() => handleRemovePair(index)} sx={{ minWidth: "auto", padding: 1 }}>
                                                            <Delete fontSize="large" />
                                                        </Button>
                                                    ) : null}
                                                </>
                                        }
                                    </Box>
                                </Box>
                            ))}
                            {/*
                            <div style={{ marginBottom: "1rem" }}>
                                <select
                                    value={"" + modelSelected}
                                    onChange={(e) => {
                                        setModelSelected(Number(e.target.value));
                                        e.target.value === "0" ? setTypeSelected(false) : setTypeSelected(true);
                                      
                                    }}
                                    style={{ padding: "0.5rem", fontSize: "1rem" }}
                                >
                                    <option value="0">Seleccionar Tipo Modelo</option>
                                    <option value="1">Start-up</option>
                                    <option value="2">Proyecto tecnológico</option>

                                </select>
                            </div>
                            */}
                            <div className="submitButtonContainer">
                                <Button
                                    type="submit"
                                    variant="contained"
                                    className="app-primary-button"
                                >
                                    {loading ? <CircularProgress size={24} color="inherit" /> : (proyecto.idProyecto === 0 ? "Guardar" : "Continuar")}
                                </Button>
                            </div>
                        </Box>

                    </form>
                </div>
                <InstructivoEcbt />
                {/*
                    modelSelected===1?<InstructivoEcbt/>:modelSelected===2?<InstructivoProyecto/>:''
*/                }
            </motion.div>
        </div>

    )
}
